import svg from "../assets/svg";

/**
 * One source for the social profiles, shared by the Vision & Mission section
 * and the footer so the URLs cannot drift apart.
 */
const socials = [
  {
    href: "https://www.facebook.com/share/p/1JCyyLPj9Z/",
    label: "Facebook",
    icon: svg.fbIconWhite,
  },
  {
    href: "https://x.com/sscharles",
    label: "X",
    icon: svg.twitterIconWhite,
  },
  {
    href: "https://www.instagram.com/josecharlesmartin?srtk=MXIweXo2YXJocWgyOQ==",
    // href: "https://www.instagram.com/jcmmakkalmandram?igsh=MWIxczZhdW45ZWY4Zg==",
    label: "Instagram",
    icon: svg.instaIconWhite,
  },
  {
    href: "https://www.linkedin.com/in/jose-charles-martin-07120745?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    label: "LinkedIn",
    icon: svg.linkedInIconWhite,
  },
];

export default socials;
